import { useNavigate, useLocation, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";
import { initAnalytics, trackPageView } from "../lib/analytics";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;
let analyticsBootstrapped = false;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  useEffect(() => {
    if (!analyticsBootstrapped) {
      initAnalytics();
      analyticsBootstrapped = true;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return element;
}
